module.exports = __webpack_public_path__ + "media/images/application/template/30-second-quote/side-opening-high-cube-6374ac094f76340c1ba30d4833cccb7e.png";